export enum TicketCalendarEventType {
    TICKET_SCHEDULATED = 1
}